<template>
  <div class="user-container">
    <div class="back" v-on:click="goBack">
      Back to Dashboard
    </div>
    <div class="button invite" v-on:click="showInviteModal">
      Invite User
    </div>

    <div class="invite-modal" v-if="inviteVisible">
      <div class="invite-form">
        <div class="modal-close" v-on:click="hideInviteModal">
          Close
        </div>

        <h2 v-if="!updateUser">Invite User</h2>
        <h2 v-if="updateUser">Update User</h2>

        <label>First Name</label>
        <div class="message" v-bind:class="{error: validation.hasError('inviteFirstName')}">{{ validation.firstError('inviteFirstName') }}</div>
        <input type="text" :disabled="updateUser" v-bind:class="{errorInput: validation.hasError('inviteFirstName')}" v-model="inviteFirstName" placeholder="First Name" maxlength="20" />

        <label>Last Name</label>
        <div class="message" v-bind:class="{error: validation.hasError('inviteLastName')}">{{ validation.firstError('inviteLastName') }}</div>
        <input type="text" :disabled="updateUser" v-bind:class="{errorInput: validation.hasError('inviteLastName')}" v-model="inviteLastName" placeholder="Last Name" maxlength="20" />

        <label>Email</label>
        <div class="message" v-bind:class="{error: validation.hasError('inviteEmail')}">{{ validation.firstError('inviteEmail') }}</div>
        <input type="text" :disabled="updateUser" v-bind:class="{errorInput: validation.hasError('inviteEmail')}" v-model="inviteEmail" placeholder="Email" maxlength="40" />

        <label>Role</label>
        <select v-model="inviteRole">
          <option value="manager">Manager</option>
          <option value="owner">Owner</option>
          <option value="user">User</option>
        </select>

        <div class="button invite-button" v-if="!updateUser" v-on:click="sendInvite">Send Invite</div>
        <div class="button invite-button" v-if="updateUser && !deleteUser" v-on:click="sendUpdate(updateUserId)">Update User</div>

        <div class="delete-user" v-if="updateUser && !deleteUser" v-on:click="toggleDeleteUser">Delete User's Account</div>
        <div class="cancel-delete" v-if="deleteUser" v-on:click="cancelDelete">Cancel Delete</div>
        <div class="confirm-delete" v-if="deleteUser" v-on:click="confirmDelete">Confirm Delete</div>
      </div>
    </div>

    <div class="list-header">
      <div class="header-column list-title">
        NAME
      </div>
      <div class="header-column list-title">
        ROLE
      </div>
    </div>

    <div
      class="list-row"
      v-for="user in users"
      v-bind:key="user._id"
      v-on:click="showUpdateModal(user)">
      <div class="column">
        <h3>{{user.first_name}} {{user.last_name}}</h3>
        <div class="email">
          {{user.email}}
        </div>
      </div>
      <div class="column">
        <div class="role" v-bind:class="{black: user.role === 'owner', blue: user.role === 'manager', red: user.role === 'admin', green: user.role === 'user'}">
          {{user.role}}
        </div>
      </div>
    </div>

    <div class="error-response" v-if="updateError">
      Error: {{errorMessage}}
    </div>
  </div>
</template>

<script>
import SimpleVueValidation from 'simple-vue-validator'
import '../styles/base.css'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'Users',
  data () {
    return {
      deleteUser: false,
      errorMessage: '',
      inviteEmail: '',
      inviteFirstName: '',
      inviteLastName: '',
      inviteRole: 'user',
      inviteVisible: false,
      updateError: false,
      updateUser: false,
      updateUserId: null,
      users: []
    }
  },

  methods: {
    cancelDelete: function () {
      this.deleteUser = false
    },

    confirmDelete: function () {
      this.axios.delete('/api/user/' + this.updateUserId)
        .then((response) => {
          this.hideInviteModal()
          this.resetUser()
          this.$parent.setCurrentMessage('User has been deleted', false)
          this.getUsers()
        })
        .catch((err) => {
          this.errorMessage = err.response
          this.$parent.setCurrentMessage('Failed to delete the user', true)
        })
    },

    getUsers: function () {
      if (PS.user.role === 'owner') {
        this.axios.get('api/users')
          .then((response) => {
            localStorage.setItem('users', JSON.stringify(response.data))
            this.users = response.data
          }).catch((errors) => {
            console.log(errors)
            localStorage.clear()
            this.$router.push('/login')
          })
      } else {
        this.$parent.setSelectedPane('slide-builder')
      }
    },

    goBack: function () {
      this.$parent.setSelectedPane('slide-builder')
    },

    hideInviteModal: function () {
      this.inviteVisible = false
      this.updateUser = false
      this.resetUser()
    },

    resetUser: function () {
      this.deleteUser = false
      this.inviteEmail = ''
      this.inviteFirstName = ''
      this.inviteLastName = ''
      this.inviteRole = 'user'
      this.updateUserId = null
    },

    sendInvite: function () {
      this.$validate().then((success) => {
        if (success) {
          let data = {
            email: this.inviteEmail,
            first_name: this.inviteFirstName,
            last_name: this.inviteLastName,
            organization_id: PS.user.organization_id,
            password: PS.user.phone,
            role: this.inviteRole
          }

          this.axios.post('/api/user', data)
            .then((response) => {
              this.sendPasswordReset(this.inviteEmail)
              this.inviteVisible = false
              this.$parent.setCurrentMessage('Your user invite has been sent.', false)
              this.getUsers()
            })
            .catch((err) => {
              this.errorMessage = err.response.data.error
              this.$parent.setCurrentMessage('Your user invite failed to send.', true)
            })
        }
      })
    },

    sendPasswordReset: function (email) {
      let data = {
        email: email
      }

      this.axios.post('/api/reset-password', data).then((response) => {

      }).catch(() => {
        this.$parent.setCurrentMessage('Failed to send user information', true)
      })
    },

    sendUpdate: function () {
      this.$validate().then((success) => {
        if (success) {
          let data = {
            role: this.inviteRole
          }

          this.axios.put('/api/user/' + this.updateUserId, data)
            .then((response) => {
              this.inviteVisible = false
              this.resetUser()
              this.$parent.setCurrentMessage('User role has been updated.', false)
              this.getUsers()
            })
            .catch((err) => {
              this.errorMessage = err.response.data.error
              this.$parent.setCurrentMessage('User role update failed.', true)
            })
        }
      })
    },

    showInviteModal: function () {
      this.inviteVisible = true
    },

    showUpdateModal: function (user) {
      if (user.role !== 'owner') {
        this.inviteVisible = true
        this.updateUser = true
        this.updateUserId = user._id
        this.inviteEmail = user.email
        this.inviteFirstName = user.first_name
        this.inviteLastName = user.last_name
        this.inviteRole = user.role
      }
    },

    toggleDeleteUser: function () {
      this.deleteUser = true
    }
  },

  props: ['refresh'],

  validators: {
    inviteEmail: function (value) {
      return Validator.value(value).required().email()
    },

    inviteFirstName: function (value) {
      return Validator.value(value).required().regex('^[A-Za-z]*$', 'Can only contain alphabetic characters.')
    },

    inviteLastName: function (value) {
      return Validator.value(value).required().regex('^[A-Za-z]*$', 'Can only contain alphabetic characters.')
    }
  },

  watch: {
    refresh: function () {
      if (this.$parent.refreshUsers) {
        this.getUsers()
      }
      this.$parent.refreshUsers = false
    }
  }
}
</script>

<style scoped>
  .back {
    float: left;
  }

  .black {
    background-color: black;
  }

  .blue {
    background-color: var(--primary);
  }

  .button {
    font-size: 1.2em;
    padding: .6em;
    width: 125px;
  }

  .cancel-delete {
    background: var(--secondary);
    color: white;
    cursor: pointer;
    font-size: 1.2em;
    margin-top: 1em;
    padding: 1em;
    text-align: center;
    width: 100%;
  }

  .cancel-delete:hover {
    background: var(--secondary-dark);
  }

  .confirm-delete {
    background: var(--error);
    color: white;
    cursor: pointer;
    font-size: 1.2em;
    margin-top: 1em;
    padding: 1em;
    text-align: center;
    width: 100%;
  }

  .confirm-delete:hover {
    background: var(--error-hover);
  }

  .column {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    font-size: .875em;
    height: 66px;
    justify-content: center;
    overflow: hidden;
    padding: 1em 1em 1em 2px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 33.33%;
  }

  .delete-user {
    color: var(--error);
    cursor: pointer;
    font-size: 1.2em;
    margin-top: 1em;
    padding: 1em;
    text-align: center;
    width: 100%;
  }

  .delete-user:hover {
    background: var(--error);
    color: white;
  }

  .email {
    color: var(--med-grey);
  }

  .error {
    color: var(--error);
  }

  .error-response {
    color: var(--error);
    margin-top: 1em;
  }

  .form-group {
    text-align: left;
  }

  .green {
    background-color: var(--secondary);
  }

  h2 {
    margin: 0 0 .5em 0;
    width: 150px;
  }

  h3 {
    font-size: 1em;
    margin: 0;
  }

  .header-column {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 33.33%;
  }

  input[type=text], input[type=email] {
    border: 1px solid #ccc;
    display: block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin-bottom: 1em;
    outline: none;
    padding: 1em;
    width: 100%;
  }

  input:focus {
    outline: 5px solid var(--focus);
  }

  .invite {
    float: right;
  }

  .invite-button {
    font-size: 1.2em;
    padding: 1em;
    margin-top: 1em;
    width: 100%;
  }

  .invite-modal {
    background-color: rgba(0,0,0, 0.8);
    height: 100%;
    left: 0;
    overflow-x: hidden;
    position: fixed;
    top: 0;
    transition: 0.5s;
    width: 100%;
    z-index: 1001;
  }

  .invite-form {
    background: white;
    left: 50%;
    overflow: scroll;
    padding: 1em;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 35%;
  }

  .modal-close {
    background: var(--secondary);
    color: white;
    padding: 1em;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  .modal-close:hover {
    background: var(--secondary-dark);
    color: white;
    cursor: pointer;
  }

  .list-header {
    align-items: flex-start;
    border-bottom: 2px solid var(--light-grey);
    display: inline-flex;
    margin-bottom: .5em;
    padding: .25em 0;
    width: 100%;
  }

  .list-row {
    align-items: flex-start;
    cursor: pointer;
    display: inline-flex;
    width: 100%;
  }

  .list-row:hover {
    background: var(--light-grey);
  }

  .list-title {
    color: var(--med-grey);
    font-weight: bold;
  }

  .message {
    display: inline-block;
    text-align: left;
  }

  .red {
    background-color: var(--error);
  }

  .role {
    border-radius: 500rem;
    color: white;
    font-size: 1.1em;
    font-weight: 600;
    min-width: 5.5em;
    padding: 8px;
    text-align: center;
    text-transform: capitalize;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    background: url('../assets/images/select-icon.svg') 98% / 4% no-repeat white;
    border: 1px solid #ccc;
    border-radius: 0;
    font-size: 1.2em;
    margin-bottom: 2em;
    padding: 1em;
    width: 100%;
  }

  .user-container {
    height: 100%;
    min-height: 100vh;
  }

  @media only screen and (max-width: 819px) {
    .column {
      width: 50%;
    }

    .header-column {
      width: 50%;
    }

    .invite-form {
      overflow: scroll;
      width: 90%;
    }

    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      appearance: none;
      background: url('../assets/images/select-icon.svg') 93% / 8% no-repeat white;
      border: 1px solid #ccc;
      border-radius: 0;
      font-size: 1.2em;
      margin-bottom: 2em;
      padding: 1em;
      width: 100%;
    }
  }

  @media only screen and (min-width: 820px) {
    .invite-form {
      width: 60%;
    }
  }

  @media only screen and (min-width: 1200px) {
    .invite-form {
      width: 40%;
    }
  }

  @media only screen and (max-height: 812px) {
    .invite-form {
      height: 80%;
    }
  }
</style>
